module.exports = __webpack_public_path__ + "79ff655614cfc10fce6f248fd58d5e39.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/accessory-detail-content/icon_link_light.png
// module id = 880
// module chunks = 0 1